import Swal from "sweetalert2";
import {
  GET_USER_OUTPUT_FORMAT_ERROR,
  GET_USER_OUTPUT_FORMAT_REQUEST,
  GET_USER_OUTPUT_FORMAT_SUCCESS,
} from "../../Types/user/Types";
import { get_User_Output_Format_Api } from "../../Apis/user/ApiConfig";

export const get_User_Output_Format_Success = (res) => {
  return {
    type: GET_USER_OUTPUT_FORMAT_SUCCESS,
    payload: res,
  };
};
export const get_User_Output_Format_Error = (error) => {
  return {
    type: GET_USER_OUTPUT_FORMAT_ERROR,
    error: error,
  };
};

export const get_User_Output_Format_Request = (res) => {
  return {
    type: GET_USER_OUTPUT_FORMAT_REQUEST,
    payload: res,
  };
};

export const get_User_Output_format_ActionHandler = (search) => {
  return (dispatch) => {
    dispatch(get_User_Output_Format_Request());
    try {
      get_User_Output_Format_Api(search)
        .then((res) => {
          if (res) {
            if (res && res?.data && res?.status === 200) {
              dispatch(get_User_Output_Format_Success(res?.data));
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                confirmButtonColor: "rgb(231,52,70)",
              });
              dispatch(get_User_Output_Format_Error(res));
            }
          } else {
            dispatch(get_User_Output_Format_Error(""));
          }
        })
        .catch((err) => {
          dispatch(get_User_Output_Format_Error("Something Went Wrong!!!"));
        });
    } catch (err) {
      dispatch(get_User_Output_Format_Error(err));
    }
  };
};
